module.exports = __webpack_public_path__ + "static/media/51.352ce7c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/51.jpg
// module id = 584
// module chunks = 0